import clsx from 'clsx';

export type GalleryView = 'magazine' | 'masonry' | 'feed';

interface GalleryToggleProps {
  value: GalleryView;
  onChange: (value: GalleryView) => void;
}

const OPTIONS: { value: GalleryView; label: string }[] = [
  { value: 'magazine', label: 'Revistă' },
  { value: 'masonry', label: 'Grilă' },
  { value: 'feed', label: 'Noutăți' },
];

export default function GalleryToggle({ value, onChange }: GalleryToggleProps) {
  return (
    <div className="inline-flex rounded-full border border-border bg-bg-alt p-xs">
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={clsx(
              'rounded-full px-md py-xs text-sm transition-colors',
              active
                ? 'bg-accent text-bg-alt'
                : 'text-fg-soft hover:text-fg'
            )}
            aria-pressed={active}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}